import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=20223cf7"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "Style/header.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Header.vue?vue&type=style&index=1&id=20223cf7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports